import {
  createTheme,
  createThemes,
  DEFAULT_PALETTE,
  DEFAULT_SUBDUED_PALETTE,
} from '@bsky.app/alf'

import {
  type AccentId,
  mergeAccentIntoPalette,
} from '#/alf/accentRamps'
import {
  buildOpenTwitterDarkPalette,
  buildOpenTwitterDimPalette,
} from '#/alf/opentwitterPalettes'

const DEFAULT_THEMES = createThemes({
  defaultPalette: DEFAULT_PALETTE,
  subduedPalette: DEFAULT_SUBDUED_PALETTE,
})

const openTwitterDarkPaletteBase = buildOpenTwitterDarkPalette(
  DEFAULT_THEMES.dark.palette,
)
const openTwitterDimPaletteBase = buildOpenTwitterDimPalette(
  DEFAULT_THEMES.dim.palette,
)

export function buildThemesForAccent(accent: AccentId) {
  const lightPalette = mergeAccentIntoPalette(
    DEFAULT_THEMES.light.palette,
    accent,
  )
  const darkPalette = mergeAccentIntoPalette(openTwitterDarkPaletteBase, accent)
  const dimPalette = mergeAccentIntoPalette(openTwitterDimPaletteBase, accent)

  const openTwitterDark = createTheme({
    scheme: 'dark',
    name: 'dark',
    palette: darkPalette,
    options: {shadowOpacity: 0.4},
  })

  const openTwitterDim = createTheme({
    scheme: 'dark',
    name: 'dim',
    palette: dimPalette,
    options: {shadowOpacity: 0.4},
  })

  const lightThemed = createTheme({
    scheme: 'light',
    name: 'light',
    palette: lightPalette,
  })

  return {
    lightPalette,
    darkPalette,
    dimPalette,
    light: lightThemed,
    dark: openTwitterDark,
    dim: openTwitterDim,
  }
}

export const themes = buildThemesForAccent('blue')

/**
 * @deprecated use ALF and access palette from `useTheme()`
 */
export const lightPalette = themes.light.palette
/**
 * @deprecated use ALF and access palette from `useTheme()`
 */
export const darkPalette = themes.dark.palette
/**
 * @deprecated use ALF and access palette from `useTheme()`
 */
export const dimPalette = themes.dim.palette
/**
 * @deprecated use ALF and access theme from `useTheme()`
 */
export const light = themes.light
/**
 * @deprecated use ALF and access theme from `useTheme()`
 */
export const dark = themes.dark
/**
 * @deprecated use ALF and access theme from `useTheme()`
 */
export const dim = themes.dim
